// extracted by mini-css-extract-plugin
export default {"link":"WB32jD4WtgyaIYpWoTBg","icon":"lKFMCNBSVcjqFvE9Twp4"};